// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1PqZq","large":"styles_large__3ypPg"};